import script from "./captchDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./captchDialog.vue?vue&type=script&setup=true&lang=js"

import "./captchDialog.vue?vue&type=style&index=0&id=eb995f76&lang=scss&scoped=true"
import "./captchDialog.vue?vue&type=style&index=1&id=eb995f76&lang=scss"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb995f76"]])

export default __exports__